import { Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { AreaModel } from 'src/app/models/area';
import { AreaService } from 'src/app/services/area.service';
import { MapService } from 'src/app/services/map.service';
import * as olProj from 'ol/proj';
import { CoordenateService } from 'src/app/services/coordenate.service';

@Component({
  selector: 'app-area',
  templateUrl: './area.component.html',
  styleUrls: ['../../app.component.scss'],
  standalone: false
})
export class AreaComponent implements OnInit {

  @Input() edit : Boolean;
  @Input() model : AreaModel;
  constructor(
    private bsModalRef : BsModalRef,
    private areaService : AreaService,
    private mapService: MapService,
    public rcsControl: CoordenateService) { }

  ngOnInit(): void {
    if(this.model == null){
      this.model = new AreaModel();
    }
  }

  cancel(): void{
    this.bsModalRef.hide();
  }

  createArea(): void{
    if (this.model.updateBounds) {
      const coordinate = olProj.toLonLat([this.mapService.getMaps().getView().getCenter()[0], this.mapService.getMaps().getView().getCenter()[1]], this.rcsControl.activeRCS.isactive ? this.rcsControl.activeRCS.epsg : "EPSG:3857");
      this.model.latitude = coordinate[1];
      this.model.longitude = coordinate[0];
      this.model.zoom = this.mapService.getMaps().getView().getZoom();
    }
    this.areaService.createArea(this.model);
    this.bsModalRef.hide();
  }

}
